import { render, staticRenderFns } from "./CoTwoFuelForm.vue?vue&type=template&id=64956e42&scoped=true&"
import script from "./CoTwoFuelForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoFuelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64956e42",
  null
  
)

export default component.exports